import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChecklistService } from 'src/app/Service/checklist/checklist.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { CommonService } from 'src/app/Service/Common.service';
import { forkJoin, Observable } from 'rxjs';

@Component({
  selector: 'app-respond-worflow-checklist-items',
  templateUrl: './respond-worflow-checklist-items.component.html',
  styleUrls: ['./respond-worflow-checklist-items.component.css']
})
export class RespondWorflowChecklistItemsComponent implements OnInit {

  selectedCheckList: any;
  checklistItemList: any[] = [];
  currentCheckID: any[] = [];
  showToast_Value: boolean = false;
  isApproveDisable: boolean = true;
  isAllButtonDisable: boolean = false;
  userUnselect: boolean = false;
  isvalid: boolean = false;
  isReadMode: boolean;
  assignlist: any;
  isSuccess:boolean = false;
  isForApproval:boolean;

  constructor(public _commonService: CommonService, public workflowTemplateService: WorkflowTemplateService, public notificationService: NotificationService,
    public checklistService: ChecklistService, public dialogRef: MatDialogRef<RespondWorflowChecklistItemsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.selectedCheckList = this.data.inputdata;
    this.isReadMode = this.data.isReadMode;
    this.assignlist = this.data.assignedvalue;
  }

  ngOnInit() {
    this.getChecklistItem();
  }

  getChecklistItem() {
    let memberId = this._commonService.getLoggedInUserId();

    let allCheckList: Observable<any> = this.checklistService.getChecklistItem(this.selectedCheckList.clId);
    let allCheckListData: Observable<any> = this.workflowTemplateService.getWorkflowChecklistItem(this.selectedCheckList);
    forkJoin(allCheckList, allCheckListData).subscribe((res: any[]) => {
      let _allCheckList: any = res[0];
      let _allCheckListData: any = res[1];

      this.checklistItemList = _allCheckList.filter((x:any) => x.isActive && !!x.cliDescription);

      if (this.checklistItemList.length <= 0) {
        this.notificationService.showToast("Selected checklist contains no items, please check", 'Warning');
        this.dialogRef.close(null);
      }

      for (let i = 0; i < this.checklistItemList.length; i++) {
        let checklistItem = this.checklistItemList[i];

        if (checklistItem.isCheck == true) {
          checklistItem.displayAction = true;
          checklistItem.childHeader = false;
        }
        else {
          checklistItem.displayAction = false;
          checklistItem.isMandatory = false;
          checklistItem.childHeader = true;
        }
        checklistItem.isChecked = null,
          checklistItem.remarks = null,
          checklistItem.isApproved = false,
          checklistItem.memberId = memberId;
      }

      for (let j = 0; j < _allCheckListData.length; j++) {
        let checklistItem = _allCheckListData[j];
        let _data = this.checklistItemList.filter(x => x.clId == checklistItem.clId && x.cliId == checklistItem.cliId);

        if (_data.length > 0) {
          _data[0].isChecked = checklistItem.isChecked;
          _data[0].remarks = checklistItem.remarks;
          _data[0].isApproved = checklistItem.isApproved;
          _data[0].memberId = checklistItem.memberId;
          if(this.data.isPerviousChecklist)
          {
            _data[0].isApproved=false;
          }
        }
      }

      if (this.checklistItemList.filter(x => x.memberId == this._commonService.getLoggedInUserId()).length > 0) {
        this.isApproveDisable = true;
      }
      else {
        this.isApproveDisable = false;
      }

      if (this.checklistItemList.filter(x => x.isApproved == true).length > 0) {
        this.isAllButtonDisable = true;
      }
      else {
        this.isAllButtonDisable = false;
      }

      if (this.isAllButtonDisable) {
        this.isApproveDisable = true;
      }
    });
  }

  closeDialog() {
    this.checkfiledemt();
    let getclDescription = {
      "currentpopupcl_Description": this.checklistItemList[0].clDescription,
      "checked_Allvalue": this.showToast_Value,
      "result": this.isSuccess,
      "copy_checklistItem" : this.checklistItemList,
      "isForApproval":this.isForApproval
    }
     this.dialogRef.close(getclDescription);
  }

  checkfiledemt() {
    let mandatoryCheckList: any[];
    let nomandatoryCheckList: any[];
    mandatoryCheckList = this.checklistItemList.filter(data => data.isMandatory == true);
    nomandatoryCheckList = this.checklistItemList.filter(data => data.isMandatory == false);
    if (mandatoryCheckList.length > 0) {
      this.showToast_Value = mandatoryCheckList.some(element => {
        // if ((!element.isChecked || element.isChecked != 1 && !element.remarks)) {
        //   return true;
        // }
        return ((!element.isChecked || element.isChecked != 1) && !element.remarks)
      });
    }
    if (nomandatoryCheckList.length > 0) {
      if (this.showToast_Value == false) {
        this.showToast_Value = nomandatoryCheckList.some(element => {
          let _isbool :boolean = false;
          if (element.displayAction == true) {
            if (!element.isChecked) {
              _isbool= true;
            }
          } else {
            element.isChecked = 0;
          }
          return _isbool;
        });
      } else {
        return;
      }
    }
  }

  onclick_Submit(isForApproval: boolean) {
    this.checkfiledemt();
    if (this.showToast_Value == true) {
      this.notificationService.showToast("Remarks or Action not taken for some of the checklist items", 'Warning');
    }
    else {
     let approvedBy =  isForApproval ? this._commonService.getLoggedInUserId() : null;
      this.checklistItemList.forEach(value => {
        value.documentId = this.assignlist.documentId,
          value.documentRevision = this.assignlist.documentRevisionNo,
          value.memberId = this.assignlist.memberId,
          value.clRevision = this.assignlist.clRevisionNo,
          value.workflowId = this.assignlist.workflowId,
          value.taskSlNo = this.assignlist.currentTaskSerialNumber,
          value["approvedBy"] = approvedBy;
      });
        this.isForApproval  =isForApproval;
      if (isForApproval == true) {
        this.notificationService.showPopup('The checklist cannot be modified once it has been approved. Are you sure you wish to proceed?', 'Confirm').then(data => {
          if (data == 'yes') {
            this.workflowTemplateService.postWorkflowChecklistItem(this.checklistItemList, isForApproval).subscribe(data => {
              // this.closeDialog();
              if (data["successCode"] == 200) {
                this.notificationService.showToast(data["successMessage"], "Success");
                this.isSuccess = true;
                this.closeDialog();
              }
              else {
                this.notificationService.showToast(data["successMessage"], "Warning");
                this.closeDialog();
              }
            })
          }
        })
      } else {
        this.workflowTemplateService.postWorkflowChecklistItem(this.checklistItemList, isForApproval).subscribe(data => {
          // this.closeDialog();
          if (data["successCode"] == 200) {
            this.notificationService.showToast(data["successMessage"], "Success");
            this.isSuccess = true;
            this.closeDialog();
          }
          else {
            this.notificationService.showToast(data["successMessage"], "Warning");
            this.closeDialog();
          }
        })
      }
    }
  }
}


